import React from 'react';
import { connect } from 'react-redux';
import './MobileWebConfirmationHeader.css';

export const MobileWebConfirmationHeaderComponent = () => {
  return (
    <div className="mobileWebHeaderContainer">
      <img className="foxNationLogoWhite" src="/account/static/images/FN/fox-nation-horizontal-white.png" alt="logo" />
    </div>
  );
};

const mapStateToProps = () => ({});

export const MobileWebConfirmationHeader = connect(mapStateToProps)(MobileWebConfirmationHeaderComponent);
